import { environment } from "../../../../../../environments/environment";
const session = JSON.parse(localStorage.getItem(environment.sessionAuth));

export const reportDiscount = {
    searchText: "",
    addText: "",
    checkbox: false,
    expandable: false,
    paginator: true,
    disabled: false,
    export: true,
    exportAllData: true,
    exportFile: 'reporte_descuento_cotización.xlsx',
    partialField: "",
    showIcon: "./assets/icon/ico_placeholder_documentos.svg",
    currency: session ? session.user.currencyCode : '',
    columns: [
      {
        title: "Nro. de cotización",
        name: "quotationNumber",
        type: "string",
        class: "center",
        value: (element: any) => element.quotationNumber,
      },
      {
        title: "Nro. de NV",
        name: "orderEanCode",
        type: "string",
        class: "center",
        value: (element: any) => element.orderEanCode,
      },
      {
        title: "Entidad de venta",
        name: "saleEntity",
        type: "string",
        class: "center",
        value: (element: any) => element.saleEntity,
      },
      {
        title: "Fecha de venta",
        name: "saleDate",
        type: "string",
        class: "center",
        value: (element: any) => element.saleDate,
      },
      {
        title: "Nro. Documento",
        name: "identityDocument",
        type: "string",
        class: "center",
        value: (element: any) => element.identityDocument,
      },
      {
        title: "Cliente",
        name: "customerName",
        type: "string",
        class: "center",
        value: (element: any) => element.customerName + ' ' + element.customerLastName,
      },
      {
        title: "Método de pago",
        name: "paymentMethod",
        type: "string",
        class: "center",
        value: (element: any) => element.paymentMethod,
      },
      {
        title: "SKU",
        name: "skuCode",
        type: "string",
        class: "center",
        value: (element: any) => element.skuCode
      },
      {
        title: "Descripción de SKU",
        name: "skuDescription",
        type: "string",
        class: "left",
        value: (element: any) => element.skuDescription,
      },
      {
        title: "Line de SKU",
        name: "skuLine",
        type: "string",
        class: "center",
        value: (element: any) => element.skuLine,        
      },
      {
        title: "Tipo de SKU",
        name: "skuType",
        type: "string",
        class: "left",
        value: (element: any) => element.skuType,
      },
      {
        title: "Fecha de pago",
        name: "paymentDate",
        type: "string",
        class: "left",
        value: (element: any) => element.paymentDate,
      },
      {
        title: "Código promoción",
        name: "promotionCode",
        type: "string",
        class: "center",
        value: (element: any) => element.promotionCode,
      },
      {
        title: "Cantidad",
        name: "units",
        type: "string",
        class: "center",
        value: (element: any) => element.units,
      },
      {
        title: "Costo",
        name: "cost",
        type: "string",
        class: "right  money",
        value: (element: any) => element.cost !== null ? reportDiscount.currency + '/ ' + element.cost :  reportDiscount.currency + '/0.00',
      },    
      {
        title: "Precio",
        name: "price",
        type: "string",
        class: "right money",
        value: (element: any) => element.price ? reportDiscount.currency + '/ ' + Number(element.price).toFixed(2) : '-',
      },
      {
        title: "Sub total",
        name: "subtotal",
        type: "string",
        class: "right  money",
        value: (element: any) => element.subtotal ? reportDiscount.currency + '/ ' + parseFloat(element.subtotal).toFixed(2) : '-',
      },
      {
        title: "Descuento",
        name: "itemDiscount",
        type: "string",
        class: "right money",
        value: (element: any) => element.itemDiscount !== null ? reportDiscount.currency + '/ ' + Number(element.itemDiscount).toFixed(2) : '-',
      },
      {
        title: "Total producto",
        name: "total",
        type: "string",
        class: "right money",
        value: (element: any) => element.total ? reportDiscount.currency + '/ ' + Number(element.total).toFixed(2) : '-',
      },
      {
        title: "Total cotización",
        name: "totalTrx",
        type: "string",
        class: "right money",
        value: (element: any) => element.totalTrx ? reportDiscount.currency + '/ ' + Number(element.totalTrx).toFixed(2) : '-',
      }
    ]
}